// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"94721564","550":"3a90ff2e","916":"f4be1d94"}[chunkId] + ".chunk.js";
};